module.exports = __webpack_public_path__ + "static/media/profile_pic.c3e38afe.png";